// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const barLabelMarginRight = "16px";
export const horizontalBarChart = "HorizontalBarChart__horizontalBarChart__wuZRY";
export const legendWrapper = "HorizontalBarChart__legendWrapper__Mjdz0";
export const textLeft = "HorizontalBarChart__textLeft__zPYrW";
export const bar = "HorizontalBarChart__bar__E0PN-";
export const member = "HorizontalBarChart__member__Zncge";
export const peers = "HorizontalBarChart__peers__KdHBA";
export const others = "HorizontalBarChart__others__gFXZE";
export const barLabel = "HorizontalBarChart__barLabel__B5BEn";
export const outerLabel = "HorizontalBarChart__outerLabel__UYmAs";
export const zeroValue = "HorizontalBarChart__zeroValue__rtNfk";